import Vue from 'vue';
import { Component, Watch, Prop, PropSync } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';

//components
// import ComponentName from './ComponentName.vue';

@Component({
    components: {        
    },
    computed:{
        ...mapGetters({

        })
    },
    methods: {
        ...mapActions({

        }),
        ...mapMutations({

        })
    },    
})
export default class ProgressRing extends Vue {
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    
    @Prop({type: Boolean, default: false }) busy !: boolean;

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: S E T T E R S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y L E : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    mounted() {

    }

    created() {

    }
} 